export enum ElementType {
  Module = 'module',
  Tracker = 'tracker',
  Pier = 'pier',
  Pcs = 'pcs',
  Site = 'project',
  AcStation = 'ac_station',
  Bess = 'bess',
  Substation = 'substation',
  Cbx = 'cbx',
  Area = 'area',
  MvCircuit = 'mv_circuit',
  CombinerBox = 'combiner_box',
  // DT3 substation sub-elements — values are the backend element_type keys (singular).
  ControlBuildingFoundation = 'control_building_foundation',
  ControlBuilding = 'control_building',
  GroundGrid = 'ground_grid',
  MptFoundation = 'mpt_foundation',
  Mpt = 'mpt',
  CapacitorBank = 'capacitor_bank',
  CapacitorBankFoundation = 'capacitor_bank_foundation',
  OtherFoundation = 'other_foundation',
  HiSideBreaker = 'hi_side_breaker',
  LoSideBreaker = 'lo_side_breaker',
}

export enum MapLayer {
  Sites = 'sites',
  ACBlock = 'pcs',
  Modules = 'modules',
  Piers = 'piers',
  Trackers = 'trackers',
  AcStations = 'ac_stations',
  Substations = 'substations',
  Bess = 'bess',
  Cbx = 'cbx',
  QC_ISSUE = 'qc_issue',
}

export enum ObservationStatus {
  Opened = 'opened',
  Resolved = 'resolved',
  Closed = 'closed',
  Draft = 'draft',
}

export enum ComplianceRecordStatus {
  Recorded = 'recorded',
  Draft = 'draft',
}

export enum ComplianceRecordStatusLabel {
  Recorded = 'Recorded',
  Draft = 'Draft',
}

export enum UserRoles {
  EPCRemediate,
  EPCCreateRemediate,
  Owner,
  SuperAdmin,
}

export enum QCStatusColorEnum {
  RED = 'red',
  GREEN = 'green',
  ORANGE = 'orange',
}

export enum QcObservationListMenuEnums {
  DELETE = 'delete',
  OPEN_MAP = 'openMap',
  EDIT = 'edit',
  NEW_TAB = 'newTab',
  PROCORE_EXPORT = 'procoreExport',
}

export enum InspectionCheckStatusEnum {
  Pass = 'pass',
  Fail = 'fail',
  NA = 'na',
}

export enum InspectionCheckStatusTextEnum {
  Pass = 'pass',
  Fail = 'fail',
  NA = 'N/A',
}

export enum InspectionStatusEnum {
  Draft = 'draft',
  InProgress = 'in_progress',
  Ready = 'ready',
  Completed = 'completed',
}

export enum ObservationAssigneeStatus {
  Added = 'added',
  Removed = 'removed',
}
